import { defineComponent as _defineComponent } from 'vue'
import CardExpand from '@/views/components/CardExpand.vue';
import SdsDateField from '@/components/SdsDateField.vue';
import moment from 'moment';
import SdsTextField from '@/components/SdsTextField.vue';
import { storeToRefs } from 'pinia';
import { useCadastroParecerReferencialStore } from '../../store/CadastroParecerReferencialStore';
import { watch } from 'vue';
import { SimNao } from '@/types/enum/SimNao';


export default /*#__PURE__*/_defineComponent({
  __name: 'CamposDadosBasicos',
  setup(__props) {

const store = useCadastroParecerReferencialStore();
const { parecerReferencial, maxDtValidade, isIntegracaoCPA, isEditing } =
  storeToRefs(store);

watch(
  () => parecerReferencial.value.dtParecer,
  async () => {
    await store.calcularDtValidade(false);
  }
);

return { __sfc: true,store, parecerReferencial, maxDtValidade, isIntegracaoCPA, isEditing, CardExpand, SdsDateField, moment, SdsTextField, SimNao }
}

})